export const COMPANY = {
  name: "Modolo Multiservices",
  phone_raw: "+34674562391",
  phone_display: "+34 674 562 391",
  email: "modolo.multiservices@gmail.com",
  cif: "Y 6163438 G",
  address_line1: "Calle Unión Europea, 10, Planta 3B",
  address_line2: "Los Montesinos — Alicante",
  maps_url:
    "https://www.google.com/maps/search/?api=1&query=Calle+Union+Europea+10+Los+Montesinos+Alicante",
  logo_url:
    "https://customer-assets.emergentagent.com/job_8a84afb4-1559-4e17-933b-35491a8b28e8/artifacts/adh0echb_WhatsApp%20Image%202026-04-22%20at%2022.40.09.jpeg",
};

export const waLink = (message) => {
  const base = `https://wa.me/${COMPANY.phone_raw.replace("+", "")}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/8a84afb4-1559-4e17-933b-35491a8b28e8/images/829cbfefe61ddbc911174ea32a33ded851a8b0a2dd69829bebeb78e4a0df7815.png",
  renovation: "https://images.pexels.com/photos/4692281/pexels-photo-4692281.jpeg",
  solar_ac: "https://images.pexels.com/photos/29206495/pexels-photo-29206495.jpeg",
  painting: "https://images.pexels.com/photos/14649379/pexels-photo-14649379.jpeg",
  ceramica: "https://images.pexels.com/photos/2762247/pexels-photo-2762247.jpeg",
  about_team: "https://images.pexels.com/photos/8960995/pexels-photo-8960995.jpeg",
  bathrooms: [
    "https://customer-assets.emergentagent.com/job_quizzical-brown-8/artifacts/pszjxh9k_WhatsApp%20Image%202026-04-24%20at%2011.53.20.jpeg",
    "https://customer-assets.emergentagent.com/job_quizzical-brown-8/artifacts/jjgv9xh0_WhatsApp%20Image%202026-04-24%20at%2011.53.19%20%283%29.jpeg",
    "https://customer-assets.emergentagent.com/job_quizzical-brown-8/artifacts/kf34pyn6_WhatsApp%20Image%202026-04-24%20at%2011.53.19%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_quizzical-brown-8/artifacts/kcrx0eb2_WhatsApp%20Image%202026-04-24%20at%2011.53.19%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_quizzical-brown-8/artifacts/9qw1zywq_WhatsApp%20Image%202026-04-24%20at%2011.53.19.jpeg",
  ],
};
